// extracted by mini-css-extract-plugin
export default {"root":"ThankYouOrder_root__Z-QMg","section":"ThankYouOrder_section__8pbxO","bold":"ThankYouOrder_bold__btmeV"};